import React from 'react';

import { NestedPlaceholderContextProvider } from 'contexts';

import Placeholder, { type Props } from './Placeholder';

/** A placeholder nested within another placeholder */
export default function NestedPlaceholder<T extends Record<keyof T, unknown>>({
	...props
}: Props<T>) {
	return (
		<NestedPlaceholderContextProvider>
			<Placeholder {...props} />
		</NestedPlaceholderContextProvider>
	);
}
NestedPlaceholder.displayName = 'NestedPlaceholder';
